var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_Delete",
    "data-name": "Icons/Delete",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M6.333,7.175.842,12.667,0,11.825,5.492,6.333,0,.841.842,0,6.333,5.492,11.825,0l.842.842L7.175,6.333l5.492,5.491-.842.842Z",
    fill: "#13112b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icons_Delete_background",
    "data-name": "Icons/Delete background",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue",
    "data-name": "Color/Liberty Blue",
    transform: "translate(1.333 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M6.333,7.175.842,12.667,0,11.825,5.492,6.333,0,.841.842,0,6.333,5.492,11.825,0l.842.842L7.175,6.333l5.492,5.491-.842.842Z",
    fill: "#13112b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-2",
    "data-name": "Color/Liberty Blue",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-3",
    "data-name": "Color/Liberty Blue",
    transform: "translate(-26.667 -26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 66.667,
    height: 66.667,
    fill: "#1a1446"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close-small.37d42f683688adeccc69e2b05e964966.svg";
export { ForwardRef as ReactComponent };